import Alert from "./Alert"
import Snackbar from "./Snackbar"

export default {
    Alert,
    Snackbar
}
